import { Chip } from '@material-ui/core';
import { DoneRounded, ScheduleRounded } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';
import { getConventionByRecord } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';

const SignedSteps = ({ opcoRecord, dataCompletion }) => {
  const { classes, css, cx, global } = useStyles(styles);

  const { data: convention = {} } = useQuery(getConventionByRecord, {
    key: ['convention', opcoRecord?.id],
    variables: { id: opcoRecord?.id },
  });

  return (
    <div className={cx(global.fcjs, css({ gap: 24 }))}>
      <div className={cx(global.title, global.blueBar)}>Avancée convention et CERFA</div>
      <div className={cx(global.fcjs, css({ gap: 4 }))}>
        <Chip 
          className={cx(convention?.content ? global.chipValid : global.chipDisabled, global.fracjs)} 
          label={convention?.content ? (
            <div className={cx(global.frac, css({gap: 12}))}><DoneRounded style={{ fontSize: 20 }} /> <div>Modèle de convention ajouté</div></div>
          ) : (
            <div className={cx(global.frac, css({gap: 12}))}><ScheduleRounded style={{ fontSize: 20 }} /> <div>Ajouté un modèle de convention</div></div>
          )
          } 
          size="medium" 
        />
        <Chip 
          className={cx(
            convention?.content
              ? dataCompletion 
                ? global.chipPending 
                : global.chipValid
              : global.chipDisabled, 
              global.fracjs
            )}  
          label={
          <div className={cx(global.frac, css({gap: 12}))}>
            {dataCompletion ? (
              <>
                <ScheduleRounded style={{ fontSize: 20 }} /> <div>Complétion des données</div>
              </>
            ) : (
              <>
                <DoneRounded style={{ fontSize: 20 }} /> <div>Données complètes</div>
              </>
            )}
          </div>
          } 
          size="medium" 
        />
          <Chip 
            className={cx(
              !dataCompletion 
                ? opcoRecord?.contract 
                  ? global.chipValid 
                  : global.chipAction
                : global.chipDisabled, 
                global.fracjs
              )}  
            label={
            <div className={cx(global.frac, css({gap: 12}))}>
              {!opcoRecord?.contract ? (
                <>
                  <ScheduleRounded style={{ fontSize: 20 }} /> <div>Contrat à envoyer</div>
                </>
              ) : (
                <>
                  <DoneRounded style={{ fontSize: 20 }} /> <div>Contrat envoyé</div>
                </>
              )}
            </div>
            } 
            size="medium" 
          />
          <Chip 
           className={cx(
            opcoRecord?.contract 
              ? opcoRecord?.contract?.status === "ARCHIVED" 
                ? global.chipValid 
                : opcoRecord?.contract?.status === "OUTDATED"
                  ? global.chipAction 
                  : global.chipPending
              : global.chipDisabled, 
              global.fracjs
            )}            
            label={
            <div className={cx(global.frac, css({gap: 12}))}>
              {opcoRecord?.contract?.status === "ARCHIVED" ? (
                <>
                  <DoneRounded style={{ fontSize: 20 }} /> <div>Contrat et convention signés</div>
                </>
              ) : opcoRecord?.contract?.status === "OUTDATED" ? (
                <>
                  <ScheduleRounded style={{ fontSize: 20 }} /> <div>Contrat et convention a regénérer</div>
                </>
              ) : (
                <>
                  <ScheduleRounded style={{ fontSize: 20 }} /> <div>Signatures en attente</div>
                </>
              )}
            </div>
            } 
            size="medium" 
        />
      </div>
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
 
});

export default SignedSteps;